import { ApplicationConfig, provideZoneChangeDetection, APP_INITIALIZER } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { ConfigService } from './app-config.service';
import { firstValueFrom } from 'rxjs';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { commonInterceptor } from './interceptors/common.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideAnimations(), 
    provideHttpClient(
      withInterceptors([commonInterceptor])
    ),
    providePrimeNG({
      theme: {
        preset: Aura,
        // if you’re not using a built-in preset, you might leave this out
        options: {
          darkModeSelector: false
        }
      }
    }),
    MessageService,
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: (config: ConfigService) => () => firstValueFrom(config.load()),
      deps: [ConfigService],
      multi: true
    },
    MessageService
  ]
};
